(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kd-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-kd-slider]').forEach(function (root) {
      if (root.dataset.ready) return; root.dataset.ready = '1';
      var track = root.querySelector('[data-track]'), dots = root.querySelectorAll('[data-dots] button');
      var n = track.children.length, i = 0, wait = +root.dataset.interval || 5000, timer;
      var go = function (k) { i = (k + n) % n; track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); };
      var mark = function () {
        var k = Math.round(track.scrollLeft / track.clientWidth); i = k;
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === k); });
      };
      track.addEventListener('scroll', function () { clearTimeout(track._t); track._t = setTimeout(mark, 80); });
      dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); restart(); }); });
      var restart = function () { clearInterval(timer); if (n > 1) timer = setInterval(function () { go(i + 1); }, wait); };
      track.addEventListener('pointerdown', restart);
      restart();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
